import {inject, Injectable, NgZone, signal} from '@angular/core';
import Clarity from '@microsoft/clarity';

@Injectable({
  providedIn: 'root',
})
export class CookieConsentService {
  #CONSENT_COOKIE_NAME = '_clck';

  readonly #ngZone = inject(NgZone);

  readonly hasConsent = signal<boolean>(false);

  constructor() {
    this.#ngZone.runOutsideAngular(() => {
      if (S2WX_CLARITY_ID) {
        Clarity.init(S2WX_CLARITY_ID);
      }
    });

    const cookieValue = document.cookie.includes(this.#CONSENT_COOKIE_NAME);

    if (cookieValue) {
      this.hasConsent.set(true);
    }
  }

  updateConsent() {
    // @ts-expect-error
    window.clarity('consent');
    this.hasConsent.set(true);
  }
}
